<footer *ngIf="offer" class="section p-4 bg-primary" id="footer">
  <div class="bg-triangle bg-triangle-light bg-triangle-bottom bg-triangle-left"></div>
  <div class="bg-triangle bg-triangle-light bg-triangle-bottom bg-triangle-right"></div>
  <div class="container">
    <div class="row align-self-center">
      <div class="col-md-4">
        <p class="p-0 m-2">
          <a href="#" class="text-white p-0" aria-label="Gryf">
            <img class="gryf-brand" style="width: 130px" src="assets/logo_gryf_white.png" alt="" loading="lazy">
          </a>
        </p>
      </div>
      <div class="col-md">
        <ul class="footer-links justify-content-center">
          <li>
            <a href="https://www.facebook.com/gryfzilina" aria-label="Facebook">
              <i class="text-white fab fa-2x fa-facebook"></i>
            </a>
          </li>
          <li>
            <a class="text-white" href="mailto:gryf@gryf.sk">
              gryf&#64;gryf.sk
            </a>
          </li>
        </ul>
      </div>
      <div class="col-md">
        <ul class="footer-links justify-content-end pr-2">
          <li>
            <a [routerLink]="['/about/op']"
               class="text-white">
              Obchodné podmienky
            </a>
          </li>
          <li class="margin-right-24">
            <a
              href="#"
              class="text-white"
              [routerLink]="['/contacts']"
              fragment="obchod"
            >
              Kontakt
            </a>
          </li>
          <li>
            <a class="text-white"
               [routerLink]="['/cookies-rules/information']">Informačná povinnosť prevádzkovateľa</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="row align-items-center pl-3">
      <div class="col-md-12 row justify-content-between pr-0">
        <div class="text-white text-muted">
          <small>
            &copy; Copyright <span class="current-year"></span> Gryf, s.r.o. All rights reserved.
          </small>
        </div>
        <div class="text-white text-muted pr-2">
          <small>
            Made with <i class="fa fa-heart"></i> in <a class="text-info" href="https://www.isw.sk/">iSW s.r.o.</a>
          </small>
        </div>
      </div>
    </div>
  </div>
</footer>
